import React, { Suspense, ReactNode } from 'react'
import { Route } from 'react-router-dom'
import CustomSwitch from 'components/CustomSwitch'
import styled from 'styled-components'
import GoogleAnalyticsReporter from '../components/analytics/GoogleAnalyticsReporter'
import AddressClaimModal from '../components/claim/AddressClaimModal'
import { ApplicationModal } from '../state/application/actions'
import { useModalOpen, useToggleModal } from '../state/application/hooks'
import DarkModeQueryParamReader from '../theme/DarkModeQueryParamReader'
import Landing from './Landing'
import Home from './Home'
import Farms from './Farms'
import Swap from './Swap'
import Pool from './Pool'
import Wallet from './Wallet'
import Schedule from './Schedule'
import Header from 'components/Header'
import Teams from './Teams'
import Coaching from './Coaching'
import Transactions from './Transactions'
import Info from './info'
import Profilepage from './Teams/ProfilePage'
import Fallback from 'components/Fallback'
import CustomRoute from 'components/CustomRoute'
import NftStats from './NftStats'
import NftStatDetail from './NftStatDetail'
import ComingSoon from 'components/ComingSoon'
const Web3ReactManager = React.lazy(async () => {
  const [moduleExports] = await Promise.all([
    import('../components/Web3ReactManager'),
    new Promise(resolve => setTimeout(resolve, 2000))
  ])
  return moduleExports
})

// import Web3ReactManager from '../components/Web3ReactManager'

const AppWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: column;
  overflow-x: hidden;
`

const StyledBodyWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  z-index: 1;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 16px;
    padding-top: 2rem;
  `};
`

function TopLevelModals() {
  const open = useModalOpen(ApplicationModal.ADDRESS_CLAIM)
  const toggle = useToggleModal(ApplicationModal.ADDRESS_CLAIM)
  return <AddressClaimModal isOpen={open} onDismiss={toggle} />
}

function BodyWrapper({ children }: { children: ReactNode }) {
  return <StyledBodyWrapper style={{ padding: 0 }}> {children} </StyledBodyWrapper>
}

export default function App() {
  return (
    <Suspense fallback={<Fallback />}>
      <Route component={GoogleAnalyticsReporter} />
      <Route component={DarkModeQueryParamReader} />
      <AppWrapper>
        <Header />
        <BodyWrapper>
          <TopLevelModals />
          <Web3ReactManager>
            <>
              <CustomSwitch>
                <Route exact strict path="/" component={Landing} />
                <CustomRoute exact strict path="/home" component={Home} />
                <CustomRoute exact strict path="/igo" component={Farms} />
                <CustomRoute exact strict path="/nftstats" component={NftStats} />
                <CustomRoute exact strict path="/nftstats/:slug" component={NftStatDetail} />
                <CustomRoute exact strict path="/swap" component={Swap} />
                <CustomRoute exact strict path="/pool" component={Pool} />
                <CustomRoute exact strict path="/wallet" component={Wallet} />
                <CustomRoute exact strict path="/calendar" component={Schedule} />
                <CustomRoute exact strict path="/team" component={Teams} />
                <CustomRoute exact strict path="/team/:ign" component={Profilepage} />
                <CustomRoute exact strict path="/accelerator" component={Coaching} />
                <CustomRoute exact strict path="/info" component={Info} />
                <CustomRoute exact strict path="/ifo" component={Info} />
                <CustomRoute exact strict path="/transactions" component={Transactions} />
                <CustomRoute exact strict path="*" component={ComingSoon} />
              </CustomSwitch>
            </>
          </Web3ReactManager>
        </BodyWrapper>
      </AppWrapper>
    </Suspense>
  )
}
